import { setLicenseKey } from 'survey-core';

export const initSurveyJsLicense = (): void => {
  const licenseKey = import.meta.env.VITE_SURVEYJS_LICENSE_KEY;

  if (!licenseKey) {
    return;
  }

  setLicenseKey(licenseKey);
};
